import { BlitsError } from "./blits.error";

export class UserNotFoundError extends BlitsError {

    static CODE = "user_not_found_code";

    constructor(message?: string) {
        super(UserNotFoundError.CODE, message || `User not found!`);
    }
}